import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Route, Routes, BrowserRouter } from "react-router-dom";
import './index.scss';
import reportWebVitals from './reportWebVitals';
import NGUCAPI from './vendor/weblink/nguc-javascript-client/API';
import Layout from './Components/Layout/Layout';
import Wallboards from './Wallboards/Wallboards/Wallboards';
import Login from './Components/Login/Login';
import Settings from './Wallboards/Settings/Settings';
import StorageTypes from './vendor/weblink/nguc-javascript-client/storage/Types';
import "../src/i18next";
import { app } from "@microsoft/teams-js";
import i18n from '../src/i18next';
import Queue from './Collaborative/Queue/Queue';
import Config from './Collaborative/Config/Config';
import Statistics from './Collaborative/Queue/Statistics/Statistics';
import './foundation.js';
import InvalidAuthTokenWrapper from './Components/invalidAuthTokenWrapper/invalidAuthTokenWrapper';
import { getCookie, setCookie } from 'typescript-cookie';
import { NgucAPIUrl, isBeta, portalDomain } from './Constants';
import PusherContextProvider from './PusherContextProvider';

const theme = getCookie('theme')

if(theme === 'dark') {
	document.body.style.backgroundColor = "#1F1F1F";
	document.body.classList.remove('light-theme')
	document.body.classList.add('dark-theme')
}

export let locale = window.navigator.language.substring(0, 2)
export let themeColor = '';

switch(locale) {
	case 'en':
	case 'sv':
		break;
	default:
		locale = 'en';
}

app.initialize()
// eslint-disable-next-line
.catch(r => {
	i18n.changeLanguage(locale);
})

// Handle change theme event
app.registerOnThemeChangeHandler((newTheme) => {
	setCookie('theme', theme === 'default' ? 'light' : 'dark')

	if(newTheme !== 'dark') {
		document.body.classList.remove('dark-theme')
		document.body.classList.add('light-theme')
		themeColor = 'light';

	} else {
		document.body.classList.remove('light-theme')
		document.body.classList.add('dark-theme')
		themeColor = 'dark';
	}
})

export const api = new NGUCAPI(
	"teams.app.1",
	(event: string, data: any) => {
		if(event === 'samlLogin' && data) {
			window.location.reload()
		}
	},
	{
		storageType: StorageTypes.cookie,
		apiUrl: isBeta ? NgucAPIUrl.beta : NgucAPIUrl.production,
	}
);

const wallboardId = getCookie('wallboardId');
const useWallboardId = api.isLoggedIn() && wallboardId && window.location.pathname !== '/settings' && window.location.pathname.indexOf('/wallboard/wallboards') === 0

// Change language according to teams context
app.getContext().then((context) => {
	if(Object.keys(context).length !== 0) {
		locale = context.app.locale === 'sv-se' ? 'sv' : 'en';
		themeColor = context.app.theme === 'default' ? 'light' : 'dark'
		setCookie('theme', themeColor)
		i18n.changeLanguage(locale);

		if(useWallboardId) {
			api.calls.user.wallboard.token.read()
			.then((token : any) => {
				const user = api.getUser();
				window.location.href = (`${isBeta ? portalDomain.beta : portalDomain.production}/company/${user.pbx_company_id}/user/${user.id}/wallboards/wallboard/${wallboardId}?wallboard_token=${token.data.token}&isTeams=1&theme=${themeColor}`);
			})
		}
	}
});

if(!useWallboardId) {
	render();
}

function render() {
	const root = ReactDOM.createRoot(
		document.getElementById('root') as HTMLElement
	);

	const redirectUrl = window.location.pathname
	const isCollaborative = redirectUrl.split('/')[1] === 'collaborative';

	root.render(
		<Suspense fallback={"loading.."}>
			<BrowserRouter>
				<Layout path={`/`}>
					<PusherContextProvider forcePusher={isCollaborative}>
						<InvalidAuthTokenWrapper>
							<Routes>
								<Route path={`/`} element={<Login />} />
								<Route path={`/login`} element={<Login redirectUrl={redirectUrl} />} />

								{	isCollaborative ?
									<>
										{/* collaborative App Routes */}
										<Route path={`/collaborative/:id`} element={<Queue />} />
										<Route path={`/collaborative/config`} element={<Config />} />
										<Route path={`/collaborative/history/statistics/:id`} element={<Statistics />} />
									</>
								:
									<>
										{/* Wallboard App Routes*/}
										<Route path={`/wallboard/wallboards`} element={<Wallboards />} />
										<Route path={`/settings`} element={<Settings />} />
									</>

								}
							</Routes>
						</InvalidAuthTokenWrapper>
					</PusherContextProvider>
				</Layout>
			</BrowserRouter>
		</Suspense>
	);
}

reportWebVitals();
